import React, { useEffect, useState } from "react";
import { Alert, CircularProgress, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { ApiUrl } from "../utils/portal-urls";
import { handleHttpResponse } from "../utils/http-helpers";

export default function AvgIntervalWidget() {
    const [rows, setRows] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        fetch(ApiUrl.Hisps.intervalData.getPath)
            .then(handleHttpResponse)
            .catch(err => {
                setLoading(false);
                if (err) console.error(err);
            })
            .then(data => {
                setLoading(false);
                if (data) setRows(data);
            });
    }, []);

    const formatDays = (val) => {
        if (val == null) return { label: '—', red: false };
        if (val < 1) return { label: `${Math.round(val * 24)} hrs`, red: false };
        return { label: `${val} days`, red: val > 3 };
    };

    return (
        <div>
            {loading && <Alert severity='info' icon={<CircularProgress size={18} />} style={{ lineHeight: '37px' }}>Loading...</Alert>}
            {!loading && !rows && <Alert severity='info' icon={false}>No data available</Alert>}
            {!loading && rows && (
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell><strong>HISP</strong></TableCell>
                            <TableCell align="right"><strong>Avg Contribution Interval</strong></TableCell>
                            <TableCell align="right"><strong>Avg Download Interval</strong></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map(row => {
                            const dl = formatDays(row.avgDownloadIntervalDays);
                            const ct = formatDays(row.avgContributionIntervalDays);
                            return (
                                <TableRow key={row.hisp}>
                                    <TableCell>{row.hisp}</TableCell>
                                    <TableCell align="right" style={ct.red ? { color: 'red', fontWeight: 'bold' } : {}}>{ct.label}</TableCell>
                                    <TableCell align="right" style={dl.red ? { color: 'red', fontWeight: 'bold' } : {}}>{dl.label}</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            )}
        </div>
    );
}
